import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DashboardLayout } from "../dashboard/DashboardLayout";
import { createSlogan } from "../../redux/actions/orderActions";
import { FaArrowLeft } from "react-icons/fa";
import { FullScreenLoader } from "../Components/Loader";
import { FiMessageSquare, FiTag, FiAlertCircle } from "react-icons/fi";

const TYPE_OPTIONS = [
  { value: "slogans", label: "Slogans" },
  // { value: "taglines", label: "Taglines" },
  // { value: "mottos", label: "Mottos" },
];

const CreateSlogan = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.slogan || {});

  const [fieldErrors, setFieldErrors] = useState({ message: "" });
  const [formData, setFormData] = useState({ message: "", type: "slogans" });
const { access_modules } = useSelector((state) => state.dealerAccess);
const sloganPerms = access_modules?.data?.find(
  (m) => m.alias === "slogans" || m.name === "Slogans"
);
const canCreate = !!sloganPerms?.is_create;
  const validateMessage = (value) => {
    const trimmed = value.trim();
    if (!trimmed) return "Slogan message is required";
    if (trimmed.length < 3) return "Message must be at least 3 characters";
    if (trimmed.length > 500) return "Message must be under 500 characters";
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "message") {
      setFieldErrors((prev) => ({ ...prev, message: validateMessage(value) }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedMessage = formData.message.trim();
    const messageError = validateMessage(trimmedMessage);
    if (messageError) {
      setFieldErrors((prev) => ({ ...prev, message: messageError }));
      return;
    }

    await dispatch(
      createSlogan(
        { message: trimmedMessage, type: formData.type || "slogans" },
        userInfo.access_token
      )
    );
    navigate("/dashboard/sloganlist");
  };
if (!canCreate && access_modules?.data) {
  return (
    <DashboardLayout>
      <div className="text-center py-20">
        <p className="text-red-500 font-bold text-lg">Access Denied</p>
        <p className="text-gray-500 text-sm mt-2">You don't have permission to create Slogans.</p>
      </div>
    </DashboardLayout>
  );
}
  return (
    <DashboardLayout>
      <FullScreenLoader
        show={loading}
        message={loading ? "Creating slogan..." : ""}
        variant="primary"
        blurIntensity="md"
      />

      <div className="relative pt-4 px-4">
        <div className="flex items-center gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="hover:text-gray-800 transition-colors p-2 hover:bg-amber-50 rounded-lg"
          >
            <FaArrowLeft size={20} />
          </button>
          <h2 className="text-2xl font-bold bg-gradient-to-r from-amber-600 to-amber-500 bg-clip-text text-transparent">
            Create Slogan
          </h2>
        </div>

        <div className="flex justify-center items-start relative z-10 pb-8">
          <div className="w-full max-w-4xl">
            <form
              onSubmit={handleSubmit}
              className="relative z-10 bg-white border-2 border-amber-500 rounded-2xl p-6 shadow-2xl space-y-6"
            >
              <div className="bg-gradient-to-br from-amber-50/30 to-white border-2 border-amber-200 rounded-xl p-5">
                <h3 className="text-lg font-semibold text-gray-950 mb-4 flex items-center gap-2">
                  <span className="text-xl">💬</span>
                  Slogan Details
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Message */}
                  <div className="relative md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Slogan Message <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <FiMessageSquare className="absolute left-3 top-3.5 text-gray-400 w-5 h-5" />
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows={4}
                        placeholder="Enter your slogan message..."
                        className={`w-full pl-10 pr-4 py-2.5 border-2 rounded-lg focus:outline-none transition resize-none ${
                          fieldErrors.message
                            ? "border-red-500 focus:border-red-500 bg-red-50"
                            : "border-gray-300 focus:border-amber-500"
                        }`}
                        required
                      />
                    </div>
                    {fieldErrors.message && (
                      <div className="mt-1.5 flex items-center gap-1 text-red-600 text-xs">
                        <FiAlertCircle size={14} />
                        <span>{fieldErrors.message}</span>
                      </div>
                    )}
                    <p className="mt-1 text-xs text-gray-400 text-right">
                      {formData.message.length}/500 characters
                    </p>
                  </div>

                  {/* Type */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Type
                    </label>
                    <div className="relative">
                      <FiTag className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                      <select
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        className="w-full pl-10 pr-4 py-2.5 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-amber-500 transition bg-white appearance-none"
                      >
                        {TYPE_OPTIONS.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end gap-4 mt-6 pt-4 border-t border-gray-200">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="bg-white border-2 border-red-500 text-red-600 py-2.5 px-6 rounded-lg hover:bg-red-50 font-semibold transition-all duration-200 shadow-sm hover:shadow-md"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-gradient-to-r from-amber-500 to-amber-600 text-white py-2.5 px-6 rounded-lg hover:from-amber-600 hover:to-amber-700 font-semibold transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                >
                  {loading ? "Creating..." : "Create Slogan"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CreateSlogan;